import { useState } from 'react';
import { SubTableColumn } from 'src/components/commons/subTable/types';

export const COLUMNS: SubTableColumn[] = [
  {
    title: 'NAME',
    dataIndex: 'name',
    editable: true,
    dataType: 'string',
    filterable: true,
    hidden: false,
    dataStructure: 'string',
    options: [],
    required: true,
    searchField: 'name',
    headerName: 'Name',
  },
  {
    title: 'DEFAULT',
    dataIndex: 'default',
    editable: true,
    dataType: 'checkbox',
    filterable: true,
    hidden: false,
    dataStructure: 'checkbox',
    required: true,
    width: 150,
    headerName: 'Default',
  },
  {
    title: 'EXCLUDE FROM MORNING EMAIL',
    dataIndex: 'excludeEmail',
    editable: true,
    dataType: 'checkbox',
    filterable: true,
    hidden: false,
    dataStructure: 'checkbox',
    required: true,
    width: 150,
    headerName: 'Exclude From Morning Email',
  },
];

export const useCallTypeHeaders = () => {
  const [columns, setColumns] = useState(COLUMNS);

  return {
    columns,
    setColumns,
  };
};
